export default class Arrays {
  static updateItem(array, uniqKey, uniqKeyValue, update) {
    const updateFunction = typeof update === "function" ? update : () => update;

    return array && array.map((item) => (item[uniqKey] === uniqKeyValue ? updateFunction(item) : item));
  }

  static removeItem(array, uniqKey, uniqKeyValue) {
    return array && array.filter((item) => item[uniqKey] !== uniqKeyValue);
  }

  static updateItemById(array, id, update) {
    return Arrays.updateItem(array, "id", id, update);
  }

  static removeItemById(array, id) {
    return Arrays.removeItem(array, "id", id);
  }

  static findByKey(array, key, value, fallback) {
    return (array && array.find((item) => item[key] === value)) || fallback;
  }

  static findById(array, id, fallback) {
    return Array.isArray(array) && Arrays.findByKey(array, "id", id, fallback);
  }

  static sort(array, props, orders) {
    if (!array) return array;

    const sortProps = Array.isArray(props) ? props : [props];

    const sortOrders = Array.isArray(orders) ? orders : [orders];

    return [...array].sort((elA, elB) => {
      return sortProps.reduce((result, current, index) => {
        if (result) return result;

        const typeFunction = typeof current === "function";

        const [propA, propB] = typeFunction
          ? [current(elA), current(elB)]
          : [elA[current], elB[current]];

        if (propA < propB) {
          return sortOrders[index] ? -1 : 1;
        }
        if (propA > propB) {
          return sortOrders[index] ? 1 : -1;
        }

        return 0;
      }, 0);
    });
  }
}
